export const PAGE_TYPE = {
  CATEGORY_LISTING: 'category_listing',
  BRAND_LISTING: 'brand_listing',
  SEARCH_LISTING: 'search_listing',
  OFFER_LISTING: 'offer_listing',
};

export const PRODUCT_CARD_ACTION = 'productCardAction';
export const OPEN_NOTIFY_ME = 'openNotifyMe';
export const TIPTILE_CLICKED = 'tiptile_clicked';
export const DEFAULT_INLINE_WIDGET_POSITION = 6;
